import moment from "moment";

export const displayMonth = (value: string): string => {
  return `${moment(value).format("MMM YYYY")}`;
};
